// extracted by mini-css-extract-plugin
export var container = "BrochureFilters-module--container--b5a15";
export var dropdown = "BrochureFilters-module--dropdown--109dc";
export var dropdownContent = "BrochureFilters-module--dropdown-content--4f051";
export var filterChip = "BrochureFilters-module--filter-chip--80989";
export var mobileContainer = "BrochureFilters-module--mobile-container--e1f52";
export var selected = "BrochureFilters-module--selected--4dda5";
export var sticky = "BrochureFilters-module--sticky--ae5ce";